<template>
  <div v-if="dataReady" class="statistics">
    <div class="row q-mb-lg">
      <div
        class="col-6"
        style="justify-content: flex-start; display: inline-flex"
      >
        <q-btn
          class="capitalize ctrl-button"
          color="ctrl-turquoise"
          :label="$store.state.stringsStore.strings.action.refresh"
          @click="fetchData()"
          icon="refresh"
        />
        <!-- Last update -->
        <p class="grey inline-button q-ml-lg">
          {{ lastUpdatedString }}
        </p>
      </div>
      <div
        class="col-6 q-pl-sm"
        style="justify-content: flex-end; display: inline-flex"
      >
        <div class="col q-mr-sm">
          <q-datetime
            format24h
            class="full-width q-mb-md"
            :float-label="'Start'"
            v-model="statsConfig.startDate"
            type="date"
            :max="Date.now()"
            @change="fetchData()"
          />
        </div>
        <div class="col q-ml-sm">
          <q-datetime
            format24h
            class="full-width q-mb-md"
            :float-label="'End'"
            v-model="statsConfig.endDate"
            type="date"
            :max="Date.now()"
            @change="fetchData()"
          />
        </div>
      </div>
    </div>
    <q-tabs v-if="showTabs" color="transparent">
      <q-route-tab
        v-for="right in getRights"
        text-color="dark"
        color="grey-9"
        :key="right + '-tab'"
        :to="getRoute(right)"
        slot="title"
        :label="getString(`module.statistics.${right}`)"
      />
    </q-tabs>
    <div
      v-for="(components, right) in componentsByRights"
      :key="right + '-pane'"
      v-show="right === getActiveTab"
    >
      <div
        v-for="(chunkedComponents, key) in chunkCharts(components)"
        :key="key"
        class="row gutter-sm q-mb-md"
      >
        <component
          v-for="component in chunkedComponents"
          :key="component"
          :type="right"
          v-bind:is="registeredComponent(component)"
          :class="`dashboard-card col-md-${
            12 / numberOfChartByRow
          } col-sm-12 col-xs-12 q-pa-sm`"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import statisticsOverview from '../statisticsOverview';

export default {
  mixins: [statisticsOverview],
  data() {
    return {
      statsConfig: {
        module: 'statistics',
        startDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      activTab: 'general',
      numberOfChartByRow: 2,
    };
  },
  methods: {
    chunkCharts(charts) {
      charts = charts.filter(
        element => this.registeredComponent(element) !== null,
      );
      const res = [];
      for (let i = 0; i < charts.length; i += this.numberOfChartByRow) {
        const chunk = charts.slice(i, i + this.numberOfChartByRow);
        res.push(chunk);
      }
      return res;
    },
    getRoute(right) {
      const route = { name: 'StatisticsOverview' };
      if (right === 'general') return route;
      route.params = { activeTab: right };
      return route;
    },
  },
  computed: {
    getActiveTab() {
      const activeTab = this.$route.params.activeTab;
      return !this.getRights.includes(activeTab) ? 'general' : activeTab;
    },
    showTabs() {
      return this.getRights.length > 1;
    },
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
